export var ToastMessageType;
(function (ToastMessageType) {
    ToastMessageType["INFO"] = "info";
    ToastMessageType["SUCCESS"] = "success";
    ToastMessageType["ERROR"] = "error";
    ToastMessageType["SIGNAL"] = "signal";
    ToastMessageType["NEUTRAL"] = "neutral";
})(ToastMessageType || (ToastMessageType = {}));
